/* eslint-disable max-len */
export const translations: any = {
  ES: {
    FORBIDDEN_RESOURCE: 'Recurso inexistente o no cuenta con los permisos necesarios',
    GUEST_MODE_LOADING_MESSAGE: 'Ingresando en modo invitado...',
    GUEST: 'Invitado',
    MENU_HOME: 'Inicio',
    MENU_MAINTANCE: 'Mantenimiento',
    MENU_WORK_ORDERS_CURRENTS: 'Órdenes de trabajo',
    MENU_WORK_ORDERS_PLANNED: 'Planes',
    MENU_WORK_ORDERS_HISTORICAL: 'Histórico',
    MENU_WORK_ORDERS_ANALYTICS: 'Análisis de Datos',
    MENU_MACHINES: 'Máquinas',
    MENU_EFFICIENCY: 'Eficiencia y productividad',
    MENU_STATIONS: 'Monitoreo de estaciones',
    MENU_FACTORY: 'Resumen de fábrica',
    MENU_SHIFT: 'Turno',
    MENU_INCIDENTS: 'Incidentes',
    MENU_ACTIVE_INCIDENTS: 'Incidentes Activos',
    MENU_HISTORICAL_INCIDENTS: 'Histórico',
    MENU_INCIDENTS_ANALYTICS: 'Análisis de Datos',
    MENU_CONFIGURATIONS: {
      MENU: 'Configuración',
      SUB_MENU_ACCOUNT: 'Cuenta',
      SUB_MENU_METRICS: 'Gateway y métricas',
    },
    MENU_SCRAP: {
      MENU: 'Merma y costos',
      SUB_MENU_ACCOUNT: 'Ingreso de datos',
      SUB_MENU_REPORTS: 'Rendimiento',
      SUB_MENU_PO_LIST: 'Reportes de rendimiento',
      SUB_MENU_COSTS: 'Costos',
    },
    MENU_NOTIFICATIONS: {
      MENU: 'Notificaciones',
    },
    MENU_FACTORY_GPT: {
      MENU: 'Inteligencia Artificial',
      SUB_MENU_REPORTS: 'Informes automatizados',
      SUB_MENU_QUERIES: 'FactoryGPT: Conversaciones',
      SUB_MENU_ALERTS: 'Alertas',
    },
    SEE_ALL: 'Ver todas las lineas',
    MENU_FACTORY_SUMMARY: {
      MENU: 'Resumen de fabrica',
      SUB_MENU_EFFICIENCY: 'Eficiencia y producción',
      SUB_MENU_AVAILABILITY: 'Disponibilidad y paros',
      SUB_MENU_REPORTS: 'Ver datos',
      SUB_MENU_QUALITY: 'Calidad',
      SUB_MENU_COMPLIANT_PRODUCT: 'Producto conforme',
      SUB_MENU_ECONOMIC_IMPACT: 'Impacto económico',
      SUB_MENU_OVERVIEW: 'Vista general',
    },
    MENU_LINE_MONITORING: {
      MENU: 'Monitoreo de estaciones',
      SUB_MENU_PROCESS_VARIABLES: 'Variables de procesos',
      SUB_MENU_PRODUCTION: 'Producción',
      SUB_MENU_REPORTS: 'Ver datos',
      SUB_MENU_MACHINES: 'Vista macro',
      SUB_MENU_PREDICTIONS: 'Predicciones',
    },
    USER_MENU_LOGOUT: 'Cerrar Sesión',
    USER_MENU_CHANGE_ACCOUNT: 'Cambiar Cuenta',
    LOGIN: 'Iniciar sesión',
    LOGIN_MESSAGE: 'Modo observador',
    LOGIN_MESSAGE_MOBILE: 'Modo observador',
    LOADING: 'Cargando',
    LOADING_MESSAGES: {
      LOGIN: 'Cargando Login',
      CONFIGURATIONS: 'Cargando Configuración',
      FACTORY_GPT: 'Cargando Factory GPT',
      EFFICIENCY: {
        STATIONS: 'Cargando módulo de eficiencia',
        SHIFT: 'Cargando la información del turno',
        FACTORY: 'Cargando resumen de fábrica',
        PROCESSING_VARIABLES: 'Cargando las variables de producción',
        ACTION_ASSIGN_STOP_REASON: 'Cargando Asignar Motivo de Paro',
      },
      NOTIFICATIONS: 'Cargando Notificaciones',
    },
    MODAL_LOGIN_PIN_LABEL_CONFIRM: 'Confirmar',
    MODAL_LOGIN_PIN_LABEL_CANCEL: 'Cancelar',
    MODAL_LOGIN_FORGOT_PASSWORD_LABEL: '¿Olvidaste tu contraseña?',
    MODAL_LOGIN_PIN_LABEL_TITLE: 'Ingrese su PIN',
    MODAL_LOGIN_PIN_ERROR_MESSAGE: 'Pin desconocido',
    MODAL_SHOW_PIN: 'Mostrar PIN',
    MODAL_HIDE_PIN: 'Ocultar PIN',
    MODAL_LOGIN_EMAIL_LABEL_EMAIL: 'Email',
    MODAL_LOGIN_EMAIL_LABEL_PASSWORD: 'Contraseña',
    MODAL_LOGIN_EMAIL_MESSAGE_INVALID_EMAIL: 'Email inválido',
    MODAL_LOGIN_EMAIL_LABEL_BUTTON: 'Ingresar',
    MODAL_LOGIN_EMAIL_LABEL: 'Email',
    MODAL_LOGIN_PIN_LABEL: 'Pin',
    MODAL_LOGIN_EMAIL_ERROR_MESSAGE: 'Correo / Contraseña incorrecta',
    MODAL_LOGIN_ERROR_UNAUTHORIZED:
      'Lo sentimos, no puedes realizar esta acción. Inicia sesión con un usuario que cuente con los permisos requeridos.',
    MODAL_LOGIN_ERROR_GUEST:
      'Te encuentras en modo observador, por favor inicia sesión para poder realizar esta acción.',
    TAB_CURRENT_WO: 'Órdenes de trabajo',
    TAB_PLANNED_WO: 'Plan de Mantenimiento',
    TAB_HISTORICAL_WO: 'Histórico',
    TAB_ANALYTICS_WO: 'Análisis de Datos',
    RESET_MODAL_CLOSE: 'Cerrar',
    RESET_MODAL_TITLE: '¡Bienvenido a Allie!',
    RESET_MODAL_BODY_TITLE: '¡Estamos muy contentos de tenerte en el equipo!',
    RESET_MODAL_BODY_SUBTITLE:
      'Antes de comenzar, hay un paso muy importante y obligatorio que debes completar: ',
    RESET_MODAL_BODY_SUBTITLE_STRONG: 'cambiar tu contraseña.',
    RESET_PIN_MODAL_BODY_SUBTITLE_STRONG: 'cambiar tu PIN.',
    RESET_PASSWORD_PLACEHOLDER: 'Ingresa tu nueva contraseña',
    RESET_VALIDATION_TITLE: 'La contraseña debe cumplir con los siguientes requisitos:',
    RESET_PIN_VALIDATION_TITLE: 'El PIN debe cumplir con los siguientes requisitos:',
    RESET_VALIDATION_MIN_LENGTH: 'Mínimo 8 caracteres',
    RESET_VALIDATION_LOWER_UPPER: 'Mayúsculas y minúsculas',
    RESET_VALIDATION_NUMBER: 'Números',
    RESET_VALIDATION_SYMBOL: 'Símbolos',
    RESET_PIN_VALIDATION_NUMBERS: 'Solamente números',
    RESET_PIN_VALIDATION_CONSECUTIVE: 'No puede haber 2 números consecutivos',
    RESET_PIN_VALIDATION_REPEAT: 'No repetir el mismo número',
    RESET_CONFIRM_PASSWORD_PLACEHOLDER: 'Confirma tu nueva contraseña',
    RESET_ACCORDION_TITLE: '¿Por qué debes cambiar tu contraseña?',
    RESET_PIN_ACCORDION_TITLE: '¿Por qué debes cambiar tu PIN?',
    RESET_ACCORDION_CONTENT_PARAGRAPH_1:
      'Cuando te registraste, te enviamos un correo electrónico con una contraseña temporal que debes usar para iniciar sesión por primera vez.',
    RESET_PIN_ACCORDION_CONTENT_PARAGRAPH_1:
      'Cuando te registraste, te enviamos un correo electrónico con un PIN temporal que debes usar para iniciar sesión por primera vez.',
    RESET_ACCORDION_CONTENT_PARAGRAPH_2:
      'Esta contraseña es aleatoria por eso te pedimos que la cambies por una que tú elijas y que solo tú sepas. De esta manera, proteges tu información personal y la de la empresa.',
    RESET_PIN_ACCORDION_CONTENT_PARAGRAPH_2:
      'Este PIN es aleatorio por eso te pedimos que la cambies por uno que tú elijas y que solo tú sepas. De esta manera, proteges tu información personal y la de la empresa.',
    RESET_CONFIRM: 'Crear nueva contraseña',
    RESET_PIN_CONFIRM: 'Crear nuevo PIN',
    RESET_SUCCESS_TITLE: '¡Felicidades!',
    RESET_SUCCESS_BODY_TITLE: 'La contraseña ha sido modificada con éxito.',
    RESET_PIN_SUCCESS_BODY_TITLE: 'El PIN ha sido modificada con éxito.',
    RESET_SUCCESS_BODY_SUBTITLE: 'Usala para iniciar sesión la próxima vez que ingreses a Allie.',
    RESET_SUCCESS_CONFIRM: 'Continuar trabajando',
    RESET_LOADING_TITLE: 'Espera mientras trabajamos',
    RESET_LOADING_SUBTITLE: 'Estamos actualizando la contraseña.',
    RESET_PIN_LOADING_SUBTITLE: 'Estamos actualizando el PIN.',
    CHAT_FLOAT_BUTTON_TITLE: 'Realiza una pregunta',
    CREATE_NEW_PASSWORD_INVALID_TOKEN:
      'El link para restablecer la contraseña es inválido o ha expirado.',
    CREATE_NEW_PASSWORD_TITLE: 'Crear una nueva contraseña',
    CREATE_NEW_PASSWORD_SUBTITLE: 'A continuación, ingresa tu nueva contraseña',
    CREATE_NEW_PASSWORD_VALIDATION_TITLE: 'Debe cumplir con los siguientes requisitos:',
    CREATE_NEW_PASSWORD_SUCCESS_BODY_TITLE: 'La contraseña ha sido creada con éxito.',
    GO_TO_MY_ACCOUNT: 'Ir a mi cuenta',
    CREATE_NEW_PASSWORD_ERROR: 'No se ha podido actualizar la contraseña',
    VALIDATING_TOKEN: 'Validando token...',
    ASSIGN_STOP_INVALID_TOKEN: 'El link para asignar el motivo de paro es inválido o ha expirado.',
    INVALID_TOKEN: 'Link es inválido o ha expirado.',
    AUTHENTICATING: 'Autenticando...',
    HELP_LABEL: 'Ayuda',
    SELECT_LANGUAGE: 'Seleccionar Idioma',
    CHANGING_LANG: 'Cambiando idioma...',
    STATIONS_ROTATION_CONTROL_PANEL: 'Panel de control',
    STATIONS_ROTATION_STATIONS_SELECTOR: 'Seleccionar estaciones',
    STATIONS_ROTATION_ROTATION_TIME: 'Tiempo de rotación',
    STATIONS_ROTATION_DISCARD: 'Regresar',
    STATIONS_ROTATION_SAVE: 'Guardar',
    MODAL_LOGIN_REMEMBER_USER: 'Recordar usuario',
    UNIT_SELECTOR_LABEL: 'Unidad',
    ALERTS: 'Alertas',
    MENU_ALERTS: {
      MENU: 'Alertas',
      SUB_MENU_ALERTS: 'Gestion de alertas',
      SUB_MENU_NOTIFICATIONS: 'Configuración',
    },
  },
  EN: {
    FORBIDDEN_RESOURCE: 'Non-existent resource or you do not have the necessary permissions',
    GUEST_MODE_LOADING_MESSAGE: 'Entering guest mode...',
    GUEST: 'Guest',
    MENU_HOME: 'Home',
    MENU_MAINTANCE: 'Maintenance',
    MENU_WORK_ORDERS_CURRENTS: 'Work orders',
    MENU_WORK_ORDERS_PLANNED: 'Plans',
    MENU_WORK_ORDERS_HISTORICAL: 'Historical',
    MENU_WORK_ORDERS_ANALYTICS: 'Data Analysis',
    MENU_MACHINES: 'Machines',
    MENU_EFFICIENCY: 'Efficiency and productivity',
    MENU_STATIONS: 'Station monitoring',
    MENU_FACTORY: 'Factory summary',
    MENU_SHIFT: 'Shift',
    MENU_INCIDENTS: 'Incidents',
    MENU_ACTIVE_INCIDENTS: 'Active Incidents',
    MENU_HISTORICAL_INCIDENTS: 'Historical',
    MENU_INCIDENTS_ANALYTICS: 'Data Analysis',
    MENU_CONFIGURATIONS: {
      MENU: 'Configuration',
      SUB_MENU_ACCOUNT: 'Account',
      SUB_MENU_METRICS: 'Gateway and metrics',
    },
    MENU_SCRAP: {
      MENU: 'Scrap and costs',
      SUB_MENU_ACCOUNT: 'Data entry',
      SUB_MENU_REPORTS: 'Performance',
      SUB_MENU_PO_LIST: 'Performance reports',
      SUB_MENU_COSTS: 'Costs',
    },
    MENU_NOTIFICATIONS: {
      MENU: 'Notifications',
    },
    MENU_FACTORY_GPT: {
      MENU: 'Artificial Intelligence',
      SUB_MENU_REPORTS: 'Automated reports',
      SUB_MENU_QUERIES: 'FactoryGPT: Conversations',
      SUB_MENU_ALERTS: 'Alerts',
    },
    SEE_ALL: 'View all lines',
    MENU_FACTORY_SUMMARY: {
      MENU: 'Factory summary',
      SUB_MENU_EFFICIENCY: 'Efficiency and production',
      SUB_MENU_AVAILABILITY: 'Availability and stops',
      SUB_MENU_REPORTS: 'View data',
      SUB_MENU_QUALITY: 'Quality',
      SUB_MENU_COMPLIANT_PRODUCT: 'Compliant product',
      SUB_MENU_ECONOMIC_IMPACT: 'Economic impact',
      SUB_MENU_OVERVIEW: 'Overview',
    },
    MENU_LINE_MONITORING: {
      MENU: 'Station monitoring',
      SUB_MENU_PROCESS_VARIABLES: 'Process variables',
      SUB_MENU_PRODUCTION: 'Production',
      SUB_MENU_REPORTS: 'View data',
      SUB_MENU_MACHINES: 'Macro view',
      SUB_MENU_PREDICTIONS: 'Predictions',
    },
    USER_MENU_LOGOUT: 'Log Out',
    USER_MENU_CHANGE_ACCOUNT: 'Change Account',
    LOGIN: 'Log In',
    LOGIN_MESSAGE: 'Observer mode',
    LOGIN_MESSAGE_MOBILE: 'Observer Mode',
    LOADING: 'Loading',
    LOADING_MESSAGES: {
      LOGIN: 'Loading Login',
      CONFIGURATIONS: 'Loading Configuration',
      FACTORY_GPT: 'Loading Factory GPT',
      EFFICIENCY: {
        STATIONS: 'Loading efficiency module',
        SHIFT: 'Loading shift information',
        FACTORY: 'Loading factory summary',
        PROCESSING_VARIABLES: 'Loading production variables',
        ACTION_ASSIGN_STOP_REASON: 'Loading Assign Stop Reason',
      },
      NOTIFICATIONS: 'Loading Notifications',
    },
    MODAL_LOGIN_PIN_LABEL_CONFIRM: 'Confirm',
    MODAL_LOGIN_PIN_LABEL_CANCEL: 'Cancel',
    MODAL_LOGIN_FORGOT_PASSWORD_LABEL: 'Forgot your password?',
    MODAL_LOGIN_PIN_LABEL_TITLE: 'Enter your PIN',
    MODAL_LOGIN_PIN_ERROR_MESSAGE: 'Unknown PIN',
    MODAL_SHOW_PIN: 'Show PIN',
    MODAL_HIDE_PIN: 'Hide PIN',
    MODAL_LOGIN_EMAIL_LABEL_EMAIL: 'Email',
    MODAL_LOGIN_EMAIL_LABEL_PASSWORD: 'Password',
    MODAL_LOGIN_EMAIL_MESSAGE_INVALID_EMAIL: 'Invalid email',
    MODAL_LOGIN_EMAIL_LABEL_BUTTON: 'Log in',
    MODAL_LOGIN_EMAIL_LABEL: 'Email',
    MODAL_LOGIN_PIN_LABEL: 'Pin',
    MODAL_LOGIN_EMAIL_ERROR_MESSAGE: 'Incorrect email / password',
    MODAL_LOGIN_ERROR_UNAUTHORIZED:
      'Sorry, you cannot perform this action. Log in with a user that has the required permissions.',
    MODAL_LOGIN_ERROR_GUEST: 'You are in observer mode, please log in to perform this action.',
    TAB_CURRENT_WO: 'Work orders',
    TAB_PLANNED_WO: 'Maintenance Plan',
    TAB_HISTORICAL_WO: 'Historical',
    TAB_ANALYTICS_WO: 'Data Analysis',
    RESET_MODAL_CLOSE: 'Close',
    RESET_MODAL_TITLE: 'Welcome to Allie!',
    RESET_MODAL_BODY_TITLE: 'We are very happy to have you on the team!',
    RESET_MODAL_BODY_SUBTITLE:
      'Before we begin, there is a very important and mandatory step you must complete: ',
    RESET_MODAL_BODY_SUBTITLE_STRONG: 'change your password.',
    RESET_PIN_MODAL_BODY_SUBTITLE_STRONG: 'change your PIN.',
    RESET_PASSWORD_PLACEHOLDER: 'Enter your new password',
    RESET_VALIDATION_TITLE: 'The password must meet the following requirements:',
    RESET_PIN_VALIDATION_TITLE: 'The PIN must meet the following requirements:',
    RESET_VALIDATION_MIN_LENGTH: 'Minimum 8 characters',
    RESET_VALIDATION_LOWER_UPPER: 'Uppercase and lowercase',
    RESET_VALIDATION_NUMBER: 'Numbers',
    RESET_VALIDATION_SYMBOL: 'Symbols',
    RESET_PIN_VALIDATION_NUMBERS: 'Numbers only',
    RESET_PIN_VALIDATION_CONSECUTIVE: 'Cannot have 2 consecutive numbers',
    RESET_PIN_VALIDATION_REPEAT: 'Cannot repeat the same number',
    RESET_CONFIRM_PASSWORD_PLACEHOLDER: 'Confirm your new password',
    RESET_ACCORDION_TITLE: 'Why do you need to change your password?',
    RESET_PIN_ACCORDION_TITLE: 'Why do you need to change your PIN?',
    RESET_ACCORDION_CONTENT_PARAGRAPH_1:
      'When you registered, we sent you an email with a temporary password that you must use to log in for the first time.',
    RESET_PIN_ACCORDION_CONTENT_PARAGRAPH_1:
      'When you registered, we sent you an email with a temporary PIN that you must use to log in for the first time.',
    RESET_ACCORDION_CONTENT_PARAGRAPH_2:
      'This password is random, which is why we ask you to change it to one of your choosing that only you know. This way, you protect your personal information and that of the company.',
    RESET_PIN_ACCORDION_CONTENT_PARAGRAPH_2:
      'This PIN is random, which is why we ask you to change it to one of your choosing that only you know. This way, you protect your personal information and that of the company.',
    RESET_CONFIRM: 'Create new password',
    RESET_PIN_CONFIRM: 'Create new PIN',
    RESET_SUCCESS_TITLE: 'Congratulations!',
    RESET_SUCCESS_BODY_TITLE: 'The password has been successfully changed.',
    RESET_PIN_SUCCESS_BODY_TITLE: 'The PIN has been successfully changed.',
    RESET_SUCCESS_BODY_SUBTITLE: 'Use it to log in the next time you access Allie.',
    RESET_SUCCESS_CONFIRM: 'Continue working',
    RESET_LOADING_TITLE: 'Please wait while we work',
    RESET_LOADING_SUBTITLE: 'We are updating the password.',
    RESET_PIN_LOADING_SUBTITLE: 'We are updating the PIN.',
    CHAT_FLOAT_BUTTON_TITLE: 'Ask a question',
    CREATE_NEW_PASSWORD_INVALID_TOKEN: 'The password reset link is invalid or has expired.',
    CREATE_NEW_PASSWORD_TITLE: 'Create a new password',
    CREATE_NEW_PASSWORD_SUBTITLE: 'Please enter your new password below',
    CREATE_NEW_PASSWORD_VALIDATION_TITLE: 'It must meet the following requirements:',
    CREATE_NEW_PASSWORD_SUCCESS_BODY_TITLE: 'The password has been successfully created.',
    GO_TO_MY_ACCOUNT: 'Go to my account',
    CREATE_NEW_PASSWORD_ERROR: 'The password could not be updated',
    VALIDATING_TOKEN: 'Validating token...',
    ASSIGN_STOP_INVALID_TOKEN: 'The link to assign the stop reason is invalid or has expired.',
    INVALID_TOKEN: 'Link invalid or has expired.',
    AUTHENTICATING: 'Authenticating...',
    HELP_LABEL: 'Help',
    SELECT_LANGUAGE: 'Select language',
    CHANGING_LANG: 'Changing language...',
    STATIONS_ROTATION_CONTROL_PANEL: 'Control panel',
    STATIONS_ROTATION_STATIONS_SELECTOR: 'Stations selector',
    STATIONS_ROTATION_ROTATION_TIME: 'Rotation time',
    STATIONS_ROTATION_DISCARD: 'Return',
    STATIONS_ROTATION_SAVE: 'Save',
    MODAL_LOGIN_REMEMBER_USER: 'Remember user',
    UNIT_SELECTOR_LABEL: 'Unit',
    ALERTS: 'Alerts',
    MENU_ALERTS: {
      MENU: 'Alerts',
      SUB_MENU_ALERTS: 'Alerts management',
      SUB_MENU_NOTIFICATIONS: 'Configuration',
    },
  },
};
